import ErrorComponent from "components/app/Error/ErrorComponent";
import { API_STATUS_CODES } from "legacy/constants/ApiConstants";
import { HOME_URL, USERS_PAGE_URL } from "legacy/constants/routes";
import ErrorPageHeader from "legacy/pages/common/ErrorPageHeader";

export function ForbiddenPage({ message }: { message: string }) {
  return (
    <>
      <ErrorPageHeader />
      <ErrorComponent
        errorCode={API_STATUS_CODES.RESOURCE_FORBIDDEN}
        title="You don't have access"
        errorMessage={message}
        buttonText="Find admins"
        buttonPath={USERS_PAGE_URL}
        secondaryButtonText="Return home"
        secondaryButtonAction={() => (window.location.pathname = HOME_URL)}
      />
    </>
  );
}
